import { IUser } from './reducer'
import { eUser } from './types'

export const updateUser = (value: IUser) => {
  return {
    type: eUser.USER,
    user: value,
  }
}
